<template>
    <!-- Loading -->
    <!-- Form -->
    <div class="vld-parent">
        <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128"></loading>
    </div>

    <vue-final-modal
    v-model="deleteModal"
    classes="flex justify-center items-center"
    :ssr="true"
    content-class="relative h-auto max-h-5/6 flex flex-col mx-4 md:mx-0 pt-2 pb-4 border dark:border-gray-800   bg-white dark:bg-gray-900 w-full md:w-1/2 lg:w-1/3"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
    >
        <jb-button
            class="absolute top-1 right-1 z-20 rounded-lg  dark:bg-gray-800 dark:text-white dark:border-gray-700"
            :icon="mdiClose"
            @click="deleteModal = false">
        </jb-button>
        <div class="space-y-3 pb-3 pl-4 z-10 shadow-lg dark:shadow-gray-200">
                <h1 class="text-2xl">{{ $t('confirmDelete.title')}}</h1>
            <slot />
        </div>
        <div class="w-full px-4 py-6">
            <p>{{ $t('confirmDelete.message')}}</p>
        </div>
        <jb-buttons class="flex justify-center w-full">
            <jb-button
                label="Confirm"
                color="info"
                @click="confirm"
                class="w-1/2  ">
            </jb-button>
            <jb-button
                label="Cancel"
                color="danger"
                outline
                @click="cancel"
                class="w-2/5  ">
            </jb-button>
        </jb-buttons>
    </vue-final-modal>

    <main-section>
        <card-component class="mt-2 content-center" :title="$t('comboardrecipients.title')" :icon="mdiReceiptTextMinus" has-table>
            <form @submit.prevent="store" class="w-full md:w-1/2 mx-auto h-full content-center">
                <div class="flex flex-wrap mb-2 content-center">
                    <p>Department</p>
                    <multiselect :options="departmentList" label="namedepartment" trackBy="namedepartment" :placeholder="$t('department.title')" v-model="recipients.department_id" mode="tags"/>
                </div>
                <div class="flex flex-wrap mb-2 content-center">
                    <p>Level</p>
                    <multiselect :options="levelListFilter" label="namelevel" trackBy="namelevel" :placeholder="$t('level.title')" v-model="recipients.level_id" mode="tags"/>
                </div>
                <div class="flex flex-wrap mb-2 content-center">
                    <p>Class</p>
                    <multiselect :options="classListFilter" label="nameclass" trackBy="nameclass" :placeholder="$t('class.title')" v-model="recipients.class_id" mode="tags"/>
                </div>
                <div v-if="toStudents" class="flex flex-wrap mb-2 content-center" >
                    <p>Students</p>
                    <multiselect  :options="studentListFilter" label="name" trackBy="name" :placeholder="$t('students.title')" v-model="recipients.student_id" mode="tags"
                    />
                </div>
                <jb-buttons class="flex flex-nowrap justify-center w-full">
                    <jb-button type="submit" color="info" :icon="mdiCheckBold"  label="Submit" class="w-3/5 md:w-auto md:px-8  "/>
                    <jb-button type="reset" color="info" :icon="mdiRefresh" outline label="Reset" class="w-3/5 md:w-auto md:px-8  " @click="reset()" />
                </jb-buttons>
            </form>

            <ag-grid-vue
                style="width: 100%; height: 70vh; margin-top: 40px;"
                class="ag-theme-alpine"
                :defaultColDef="defaultColDef"
                :columnDefs="columnDefs"
                v-text-v-html="keyData"
                :pagination="true"
                :context="context"
                @grid-ready="onGridReady"
                :rowData="rowData.value"
            />
        </card-component>
    </main-section>
</template>
<script>
    /* eslint-disable */
    import axios from 'axios'
    import {
        onMounted,
        ref,
        reactive,
        onUpdated,
        watch,
        watchEffect
    } from 'vue'
    import {
        mdiCashMultiple,
        mdiPlusCircleOutline,
        mdiTrashCan,
        mdiCircleEditOutline,
        mdiRefresh,
        mdiClose,
        mdiMagnify,
        mdiCheckBold,
        mdiReceiptTextMinus
    } from '@mdi/js'
    import MainSection from '@/components/MainSection'
    import Multiselect from '@vueform/multiselect'
    import HeroBar from '@/components/HeroBar'
    import TitleBar from '@/components/TitleBar'
    import Control from '@/components/Control'
    import { useRouter } from 'vue-router'
    import { AgGridVue } from 'ag-grid-vue3'
    import Field from '@/components/Field'
    import CardComponent from '@/components/CardComponent'
    import { useStore } from 'vuex'
    import { useToast } from 'vue-toastification'
    import JbButtons from '@/components/JbButtons'
    import JbButton from '@/components/JbButton'
    import ButtonRecipients from '@/components/ButtonRecipients'
    import Divider from '@/components/Divider'
    import { useI18n } from 'vue-i18n'
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css'
    import '@vuepic/vue-datepicker/dist/main\.css'
    import { getDepartmentDataAll } from '@/composables/global'

    export default {
        components: {
            MainSection,
            Loading,
            AgGridVue,
            TitleBar,
            CardComponent,
            HeroBar,
            JbButtons,
            JbButton,
            Divider,
            Control,
            Field,
            Multiselect,
            ButtonRecipients
        },
            props: {
            propRecipients: {
                type: Object,
                default: () => ({
                empty: true
                })
            },
            propComboards: {
            type: Object,
            default: () => ({ empty: true }),
            },
        },
        data: function () {
            return {}
        },
        emits: ['close-modal', 'submit', 'click-refresh'],
        setup (props, { emit }) {
            const { t } = useI18n()
            const rowData = reactive([])
            const filteredData = reactive([])
            const router = useRouter()
            const isLoading = ref(false)
            const { departmentList } = getDepartmentDataAll()
            const recipients = reactive({
                id: '',
                department_id: [],
                comboard_id:'',
                class_id: [],
                level_id: [],
                student_id: [],
                created_by: '',
                updated_by: ''
            })
            const reset = () => {
                recipients.department_id = []
                recipients.class_id = []
                recipients.level_id = []
                recipients.student_id = []
            }

            const toStudents = ref(false)
            const levelListFilter = ref([])
            const studentListFilter = ref([])
            const classListFilter = ref([])
            const str = useStore()
            const userlogin = localStorage.getItem('name')
            const toast = useToast()
            const titleStack = ref(['Comboard Recipients', 'Dashboard'])
            const recipientsModal = ref(false)
            const deleteModal = ref(false)
            const recipientsObject = ref()
            const confirm = () => confirmDelete()
            const cancel = () => deleteModal.value = false
            const columnDefs = [
                { headerName: '#', valueGetter: 'node.rowIndex+1', width: 60 },
                {
                    field: 'info',
                    headerName: 'Invitation',
                    sortable: true,
                    filter: true,
                    width: 300,
                    cellRenderer: function (params) {
                    let keyData = params.data.info;
                    return keyData
                    }
                },
                {
                    field: 'department_name',
                    headerName: 'Department',
                    sortable: true,
                    filter: true,
                },
                {
                    field: 'level_name',
                    headerName: 'Level',
                    sortable: true,
                    filter: true,
                },
                {
                    field: 'class_name',
                    headerName: 'Class',
                    sortable: true,
                    filter: true,
                },
                {
                    field: 'student_name',
                    headerName: 'Student',
                    sortable: true,
                    filter: true,
                },
                {
                    field: 'created_at',
                    headerName: 'Date Created',
                    sortable: true,
                    filter: true,
                },
                {
                    field: 'id',
                    headerName: t('main.action'),
                    sortable: true,
                    filter: true,
                    minWidth: 165,
                    cellRendererFramework: 'ButtonRecipients'
                }
            ]
            const defaultColDef = {
                resizable: true
            }
            const refresh = async () => {
                isLoading.value = true
                await axios
                    .get(
                        'comboard-recipients',{
                        params:{
                            comboard_id: props.propComboards.comboard_id
                        }
                    })
                    .then(response => {
                        rowData.value = response.data.data.filter(item => item.comboard_id == recipients.comboard_id)
                        isLoading.value = false
                    })
                    .catch(error => {
                        toast.error(error, { timeout: 5000 })
                        isLoading.value = false
                    })
            }
            onMounted(() => {
                // refresh()
            })
            onUpdated(() => {
                //refresh()
            })

            const store = async() => {
                isLoading.value = true
                const url = 'comboard-recipients'
                const method = 'POST'
                recipients.created_by = userlogin
                const dataSubmit = {
                    department_id:[...recipients.department_id],
                    class_id:[...recipients.class_id],
                    level_id:[...recipients.level_id],
                    student_id:[...recipients.student_id],
                    comboard_id:recipients.comboard_id,
                    created_by:userlogin
                }

                const config = {
                    headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    },
                };

                axios.post(url, dataSubmit, config)
                    .then(response => {
                        if (response.data.success) {
                            emit('reset-modal')
                            emit('close-modal')
                            emit('click-refresh')
                            toast.success(response.data.message)
                            isLoading.value = false
                        } else {
                            errors.value = response.data.messages
                            toast.error(response.data.messages)
                        }
                        reset()
                        refresh()
                    })
                    .catch(error => {
                        isLoading.value = false
                        console.log(error)
                    })
            }
                // mounted
            onMounted(() => {
                // ambilData()
            })
            watch(() => props.propClass, (newVal, oldVal) => {
            })

            const comboardHeaderList = ref()
            const ambilData = async () => {
            // isLoading.value = true
                const user_parent = localStorage.getItem('user_id')
                const role = localStorage.getItem('roles')
                const url = 'studentall'
                const method = 'GET'
                const params = {
                class_id:recipients.class_id,
                user_parent_id: user_parent,
                roles: role
                }
                await axios
                .get('students')
                axios({
                    method,
                    url,
                    params: params
                })
                .then(response => {
                        isLoading.value = false
                        if(recipients.class_id == 'All'){
                            studentListFilter.value = [{value: 'All'}]
                        }else{
                            studentListFilter.value = response.data.data
                        }
                })
                .catch(error => {
                    console.log(JSON.stringify(error))
                    isLoading.value = false
                })
            }

            const ambilDataClass = async () => {
                // isLoading.value = true
                const user_parent = localStorage.getItem('user_id')
                const role = localStorage.getItem('roles')
                const url = 'classall'
                const method = 'GET'
                const params = {
                level_id:recipients.level_id,
                user_parent_id: user_parent,
                roles: role
                }
                await axios
                .get('class')
                axios({
                    method,
                    url,
                    params: params
                })
                .then(response => {
                        isLoading.value = false
                        if(recipients.level_id == 'All'){
                            classListFilter.value = [{nameclass: 'ALL', value: 'All'}]
                        }else{
                            classListFilter.value = response.data.data
                        }
                })
                .catch(error => {
                    console.log(JSON.stringify(error))
                    isLoading.value = false
                })
            }

            const ambilDataLevel = async () => {
                const role = localStorage.getItem('roles')
                const user_parent = localStorage.getItem('user_id')
                const url = 'levelall'
                const method = 'GET'
                const params = {
                department_id:recipients.department_id,
                user_parent_id: user_parent,
                roles: role
                }
                await axios
                .get('level')
                axios({
                    method,
                    url,
                    params: params
                })
                .then(response => {
                    isLoading.value = false
                    if(recipients.department_id == 'All'){
                        levelListFilter.value = [{namelevel: 'ALL', value: 'All'}]
                        // recipients.level_id = 'All'
                    }else{
                        levelListFilter.value = response.data.data
                    }
                })
                .catch(error => {
                    console.log(JSON.stringify(error))
                    isLoading.value = false
                })
            }

            watchEffect(() => {
                const newrecipients = props.propComboards
                toStudents.value = props.propComboards.to_student
                Object.assign(recipients, newrecipients)
                refresh()
            })
            watch(() => recipients.comboard_id, (newHead, oldHead) => {
                //getComboard(newHead)
            })
            watch(() => recipients.department_id, (newDep, oldDep) => {
                ambilDataLevel()
            watch(() => recipients.level_id, (newlevel, oldLevel) => {
                ambilDataClass()
                })
            watch(() => recipients.class_id, (newClass, oldClass) => {
                ambilData()
                })
            })

            const hideModal = () => {
                recipientsModal.value = false
            }
            const showModal = () => {
                recipientsModal.value = !recipientsModal.value
            }
            const deleteModalShow = (value) => {
                deleteModal.value = true
                deleteModal.id = value.id
            }
            const confirmDelete = () => {
                axios
                .delete(`comboard-recipients/${deleteModal.id}`)
                .then(response => {
                    if (response.data.success) {
                        refresh()
                        deleteModal.value = false
                        toast.success(response.data.message, { timeout: 5000 })
                    }
                })
                .catch(error => {
                console.log(error)
                })
            }

            return {
                t,
                titleStack,
                recipients,
                mdiReceiptTextMinus,
                classListFilter,
                levelListFilter,
                studentListFilter,
                store,
                isLoading,
                mdiPlusCircleOutline,
                mdiClose,
                mdiMagnify,
                mdiCashMultiple,
                mdiTrashCan,
                mdiCircleEditOutline,
                mdiCheckBold,
                recipientsObject,
                recipientsModal,
                hideModal,
                showModal,
                rowData,
                defaultColDef,
                filteredData,
                mdiRefresh,
                router,
                str,
                userlogin,
                deleteModal,
                deleteModalShow,
                confirm,
                cancel,
                confirmDelete,
                comboardHeaderList,
                ButtonRecipients,
                recipients,
                departmentList,
                columnDefs,
                reset,
                Agridpi: null,
                gridColumnApi: null,
                toStudents,
                Multiselect
            }
        },
        beforeMount() {
            this.context = {
                componentParent: this
            }
        },
        methods: {
            onGridReady (params) {
            }
        },
        clearForm () {
            this.recipients = reactive({
                    id: '',
                    department_id: [],
                    comboard_id:'',
                    class_id: [],
                    level_id: [],
                    student_id: [],
                    created_by: ''
            })
        }
}
</script>
<style scoped>
section.main-section{
    padding: 0px 16px 16px 16px !important;
}
.ag-theme-alpine{
    height: fit-content !important;
}
</style>
<style src="@vueform/multiselect/themes/default.css"></style>
